import { useEffect } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom'
import { track } from '../../../../logic'
import { getPayloadErrorMessage } from '../../../../utils/payloadErrorCodes'
import { ErrorDialog } from '../../dialogs/ErrorDialog'
import { useOrganization } from '../../../OrganizationProvider'

export type EarnestMoneyPayloadErrorSource = 'bank_account' | 'check'

export type EarnestMoneyPayloadError = {
  error: any,
  source: EarnestMoneyPayloadErrorSource,
}

// Shared error handling for EMD Payload payments (bank account checkout and check form)
export function EarnestMoneyPayloadErrorDialog({ payloadError, onClose }: {
  payloadError: EarnestMoneyPayloadError,
  onClose: () => void,
}) {
  const { closingId } = useParams()
  const { search } = useLocation()
  const { CompanyDisplayName } = useOrganization()

  // Track in an effect so re-renders don't send duplicate events
  useEffect(() => {
    track('error', 'payload form', {}, {
      message: JSON.stringify(payloadError.error),
      component: 'EarnestMoneyTaskPayload',
      paymentType: payloadError.source,
    })
  }, [payloadError])

  const errorMessage = getPayloadErrorMessage(payloadError.error)
  const paymentMethodText = payloadError.source === 'check' ? 'this check' : 'this account'

  return (
    <ErrorDialog titleText='Payment could not be processed' onClose={onClose} onTryAgain={onClose}>
      <>
        {errorMessage && <>{errorMessage}{' '}</>}
        We couldn't complete your payment from {paymentMethodText} at this time. Please try again with a different payment method or contact {CompanyDisplayName} for alternative payment instructions. Contact information is available in the{' '}
        <Link to={`/closing/${closingId}/closing-contacts${search}`}>contacts section</Link>.
      </>
    </ErrorDialog>
  )
}
